import { render, staticRenderFns } from "./videoConfSectionHeaderShare.vue?vue&type=template&id=cc0f5518&scoped=true&lang=pug&"
import script from "./videoConfSectionHeaderShare.vue?vue&type=script&lang=js&"
export * from "./videoConfSectionHeaderShare.vue?vue&type=script&lang=js&"
import style0 from "./videoConfSectionHeaderShare.vue?vue&type=style&index=0&id=cc0f5518&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0f5518",
  null
  
)

export default component.exports